import { render } from "./GlobalLayoutView.vue?vue&type=template&id=70456fdc"
import script from "./GlobalLayoutView.vue?vue&type=script&lang=js"
export * from "./GlobalLayoutView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__